var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DropdownActionItem',{staticClass:"flex items-center",attrs:{"data-test-id":"message"},on:{"click":_vm.compose}},[_vm._v(" Message ")])
}
var staticRenderFns = []

export { render, staticRenderFns }